<template>
    <div class="wrapper">

        <div class="padding-sm bg-white min-height flex-sub">

            <div class="flex flex-direction justify-between margin-bottom">
                <div class="flex align-center justify-between  list-search margin-bottom-sm">
                    <el-select v-model="level" class="margin-right-sm flex-shrink" placeholder="请选择分会等级">
                        <el-option
                            v-for="item in levelList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input v-model="keyWord" placeholder="请输入分会名称"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                </div>
                <div class="  flex align-center member-set">
                    <router-link class="margin-right" to="/organization/members/orgCreat/0">
                        <div>分会录入</div>
                    </router-link>
<!--                    <router-link class="margin-right" to="/organization/setup/binvitation">-->
<!--                        <div>分会邀请</div>-->
<!--                    </router-link>-->
                    <el-link
                        class="margin-right"
                        :href="baseURL + 'admin/excel/userPinShuExportExcel?mid=' + user.mid + '&sign=' + user.sign + '&rank_id='+level+'&status='+fee+'&time='+time+'&is_locking='+lock+'&keyword=' + keyWord"
                        :underline="false">
                        <div>证书信息导出</div>
                    </el-link>
                    <el-upload
                        :action="baseURL + 'admin/excel/userPinShuImportExcel'"
                        :data="fileData"
                        :on-success="handleAvatarSuccess"
                        :show-file-list="false"
                    >证书信息导入
                    </el-upload>
                </div>
            </div>
            <div class="ship-list ">
                <el-table
                    v-loading="loading"
                    :data="lists" border
                    header-row-class-name="table-header"
                    style="width: 100%; border-radius: 10px">
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.$index + 1 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="分会名称" prop="company" width="220px">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.name  }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="分会等级" prop="rankname">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.rankname || '--' }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="联系人" prop="name">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.lianxiren }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="手机号" prop="phone">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.lianxidianhua }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="积分" prop="integral">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.integral }}分
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220px">
                        <template slot-scope="scope">
                            <div class="flex justify-center  align-center">
                                <el-link class="table-operate" @click="itemDetail(scope.row.id)">查看</el-link>
                                <el-link class="table-operate" @click="itemCertificate(scope.row.id)">聘书</el-link>
                                <el-link class="table-operate" @click="itemManager(scope.row.id)">管理</el-link>
                                <el-link class="table-operate" @click="itemPower(scope.row.id)">权限</el-link>
                                <el-link class="table-operate active" @click="itemDel(scope.row.id)">删除</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top"
                layout="prev, pager, next, jumper"
                @current-change="listOrgFenHui">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {delOrgFenHui, listOrgFenHui,getRankList} from "@/api/organiz";
import {baseURL} from "@/config";
export default {
    name: "orgList",
    data() {
        return {
            baseURL: baseURL,
            keyWord: '',
            lists: [],
            page: 1,
            limit: 15,
            total: 0,
            loading: false,
            levelList: [{
                id: 0,
                name: "全部"
            }],
            level: '',
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                mid: this.user.mid,
                sign: this.user.sign,
            }
        }
    },
    created() {
        this.$emit('setIndex', [8, 0], '分会管理')
        this.listOrgFenHui()
        this.getRankList()
    },
    components: {},
    methods: {
        // 获取等级
        async listOrgFenHui() {
            this.loading = true
            let _list = await listOrgFenHui(this.level,this.keyWord, this.page, this.limit)
            this.lists = _list.data
            this.total = _list.count
            this.loading = false
        },
        search() {
            this.page = 1
            this.listOrgFenHui()
        },
        itemDetail(id) {
            this.$router.push(`/organization/members/orgCreat/${id}`)
        },
        itemCertificate(id) {
            this.$router.push('/organization/members/fcertificate/' + id)
        },
        itemPower(id) {
            this.$router.push('/organization/members/power/' + id)
        },
        async itemManager(id) {
            this.user.fhid = id
            this.user.isBranch = false
            this.$store.state.user = this.user
            await window.localStorage.setItem('user', JSON.stringify(this.user))
            window.open(`/vw/branch`)
        },
        itemDel(id) {
            this.$confirm('此操作将删除该分会, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(id)
            })
        },
        async sureDelete(id) {
            let _state = await delOrgFenHui(id)
            if (_state.code === 1) {
                this.$message.success(_state.msg)
                await this.listOrgFenHui()
            }
        },
        //  获取等级列表
        async getRankList() {
            let _list = await getRankList(2)
            this.levelList = [...this.levelList, ..._list.data]
        },
        //  上传成功
        handleAvatarSuccess(file) {
            if (file.status === 200) {
                this.$message.success(file.msg)
                this.userList()
            } else {
                this.$message.error(file.msg)
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.wrapper {
    .classifys {
        margin-bottom: 20px;

        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            color: #ffb400;
            border-radius: 0 6px 6px 0;

            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 6px 0 0 6px;
            }
        }
    }

    .member-set {
        div {
            width: 171px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            background-color: #f3f7fb;
            border-radius: 10px;
            border: solid 1px #dae0e6;
            font-size: 18px;
            cursor: pointer;

            &:hover {
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#0a2240, #0a2240);
                background-blend-mode: normal, normal;
                color: #fff;
            }
        }
    }

    .list-search {
        .el-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background: #0a2240;
            border: 0;
            font-size: 16px;
        }
    }

    .table-name {
        font-size: 14px;
        color: #333333;
        text-align: center;

        &.gray {
            color: #999999;
        }
    }

    .table-operate {
        color: #ffa11a;
        margin: 0 5px;

        &.active {
            color: #e4396c;
        }

    }
}
</style>
